import PropTypes from 'prop-types';

export const LinkPropTypes = {
  typeLink: PropTypes.string,
  linkIdentifier: PropTypes.string,
  groupIdentifier: PropTypes.string,
  isNofollow: PropTypes.bool,
  picto: PropTypes.string,
  alt: PropTypes.string,
  urlKeyword: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  subtext: PropTypes.string,
  img: PropTypes.string,
  showEc: PropTypes.bool,
  showText: PropTypes.bool,
  pictoComponent: PropTypes.object,
  identifierLink: PropTypes.string
};
